import { render } from "./StoryForm.vue?vue&type=template&id=2074d872"
import script from "./StoryForm.vue?vue&type=script&lang=js"
export * from "./StoryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__